/*
 * View for Contents Controls
 */

define([
  "marionette",
  "modules/contentsSplit/contents/contentsList/contentsControls/template/contentsControlsTemplate.html",
], function (Marionette, ContentsControlsTemplate) {
  var ContentsControlsView = {};

  ContentsControlsView.contentsControlsView = Marionette.ItemView.extend({
    template: ContentsControlsTemplate,
    clearControlsError: function () {
      this.$el.find("#controlsError").html("");
    },
    controlsError: function (errorMessage) {
      this.$el
        .find("#controlsError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    events: {
      "change #contentAwarenessFilter select": function () {
        var optionSelected = this.$el.find("#contentAwarenessFilter select option:selected").val();
        if (optionSelected === "missing") {
          this.trigger("missing:content:folder");
        } else if (optionSelected === "modified") {
          this.trigger("modified:content:folder");
        } else if (optionSelected === "ignored") {
          this.trigger("ignored:content:folder");
        } else {
          this.trigger("all:content:folder");
        }
      },
    },
    nameError: function (errorMessage) {
      this.$el
        .find("#contentFolderText")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: {
      "#contentFolderText": {
        enableSelector: "#contentFolderText",
        modelAttribute: "groupName",
        placeholder: "contents.controls.folderPlaceholder",
        textArea: false,
      },
    },
    triggers: {
      "click #deleteContents": "delete:contents",
      "click #moveContents": "move:contents",
      "click #addFolder": "add:folder",
      "click #moveFolder": "move:folder",
      "click #deleteFolder": "delete:folder",
      "click #modifiedContent": "modified:content:folder",
      "click #missingContent": "missing:content:folder",
      "click #ignoredContent": "ignored:content:folder",
      "click #newContent": "new:content:folder",
    },
  });

  return ContentsControlsView;
});
